import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { CharterFilingService } from '@wealthlane/api-services/wealthlane-captable-service';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '@wealthlane/api-services/wealthlane-captable-service';
import ToastComponent from '../../components/toast';

const usePostEditCharterFiling = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal?: () => void,
  charterFilingId?: string
): UseMutationResult<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined, unknown, any> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (charterFilingId) {
        return await handleRequest(
          CharterFilingService.postApiCapTableApiAppCharterFilingEditCharterFiling(
            charterFilingId,
            payload
          )
        );
      }
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          await queryClient.invalidateQueries('getCharterFilings');
          await queryClient.invalidateQueries('getShareClassSnapshots');
          await queryClient.invalidateQueries('getStockClassList');
          closeModal?.();
          toast.success(<ToastComponent label='Success' message='Charter filing updated successfully.' />);
        }
      },
    }
  );
};

export default usePostEditCharterFiling;
